import { Injectable } from '@angular/core';
import { FamilyCertificate, ProductFamily } from './product-family.model';
import { MatTableDataSource } from '@angular/material/table';
import { RestProductFamiliesService } from 'src/app/service/rest/product-families/rest-product-families.service';
import { Observable } from 'rxjs';
import { ArticleCodesRepositoryService } from '../article-code/article-codes-repository.service';

@Injectable()
export class ProductFamilyRepositoryService {
  
  private _dataSourceProductFamilies: MatTableDataSource<ProductFamily> = new MatTableDataSource<ProductFamily>();
  private _productFamilies: ProductFamily[] = [];
  private _productFamiliesLoaded: boolean = false;
  private _familiesCertificates: FamilyCertificate[] = [];
  private _productFamiliesCertificatesLoaded: boolean = false;
  private _selectedFamily: ProductFamily;
  
  
  constructor(
    private restProductFamilyService: RestProductFamiliesService,
    private articleCodesRepository: ArticleCodesRepositoryService
  ) { }
  
  public get dataSourceProductFamilies(): MatTableDataSource<ProductFamily> {
    return this._dataSourceProductFamilies;
  }
  public set dataSourceProductFamilies(value: MatTableDataSource<ProductFamily>) {
    this._dataSourceProductFamilies = value;
  }
  
  public get productFamilies(): ProductFamily[] {
    return this._productFamilies;
  }
  public set productFamilies(value: ProductFamily[]) {
    this._productFamilies = value;
  }
  
  public get productFamiliesLoaded(): boolean {
    return this._productFamiliesLoaded;
  }
  public set productFamiliesLoaded(value: boolean) {
    this._productFamiliesLoaded = value;
  }
  
  public get familiesCertificates(): FamilyCertificate[] {
    return this._familiesCertificates;
  }
  public set familiesCertificates(value: FamilyCertificate[]) {
    this._familiesCertificates = value;
  }
  
  public get productFamiliesCertificatesLoaded(): boolean {
    return this._productFamiliesCertificatesLoaded;
  }
  public set productFamiliesCertificatesLoaded(value: boolean) {
    this._productFamiliesCertificatesLoaded = value;
  }
  
  public get selectedFamily(): ProductFamily | undefined {
    return this._selectedFamily;
  }
  public set selectedFamily(value: ProductFamily | undefined) {
    this._selectedFamily = value;
    
    console.log('Setting selectedFamily:', value);
    
    // Automatically load articles for the selected family
    if (value && value.id) {
      console.log('Loading articles for family from API...');
      this.articleCodesRepository.loadArticleCodesByFamilyId(value.id).subscribe(
        articles => {
          console.log('Loaded articles for family', value.id, ':', articles.length);
          console.log('Articles:', articles);
          this.articleCodesRepository.selectedArticleCodes = articles;
          this.articleCodesRepository.dataSourceArticleCodes.data = articles;
        },
        error => {
          console.error('Error loading articles for family:', error);
          // Reset articles if there's an error
          this.articleCodesRepository.selectedArticleCodes = [];
          this.articleCodesRepository.dataSourceArticleCodes.data = [];
        }
      );
    } else {
      // If no family is selected, clear the articles
      console.log('No family selected, clearing articles');
      this.articleCodesRepository.selectedArticleCodes = [];
      this.articleCodesRepository.dataSourceArticleCodes.data = [];
    }
  }
  
  loadProductFamilies(): Observable<ProductFamily[]> {
    return this.restProductFamilyService.getAllProductFamilies();
  }
  
  loadFamiliesCertificates(): Observable<FamilyCertificate[]> {
    return this.restProductFamilyService.getAllProductFamiliesCertificates();
  }
  
  uploadCertificateFile(file: File): Observable<FamilyCertificate> {
    return this.restProductFamilyService.uploadFamilyCertificate(file);
  }
}
